import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#9c8cff',
        secondary: '#c1b7fe',
        accent: '#ffb978',
        error: '#ff5f5f',
        base: '#9c8cff',
        lighten2: '#f3f1ff',
        lighten1: '#e4dfff',
        darken1: '#777777',
        darken2: '#9c8cff',
        darken3: '#808080',
        darken4: '#e5e5e5',
        darken5: '#f5f5f5',
        'darken-2': '#9c8cff',
        purple: '#9c8cff',
        'purple-light': '#e4dfff',
        'purple-lighter': '#f3f1ff',
        green: '#1ca021',
        'green-light': '#4caf50',
        gray: '#cecece',
        orange: '#fd881b',
        'red-light': '#ff5f5f',
      },
    },
  },
});
